var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 151,
    viewBox: "0 0 1512 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1512 151L0 0V151H1512Z",
    fill: "#5CB4F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleB);
export default __webpack_public_path__ + "static/media/triangle-b.9a5fc8b715f850661f7d922d12f104b6.svg";
export { ForwardRef as ReactComponent };